import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'passLabelModify',
})
export class PassLabelPipe implements PipeTransform {
    transform(value: string): unknown {
        const passLabelString = value.split(' ');
        return `${passLabelString[1]} ${passLabelString[3]}`;
    }
}
